__turbopack_context__.v({
  "className": "IuS3nG_className",
  "variable": "IuS3nG_variable",
});
